import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function RankingItem({ data, maxPoints }) {
  const { rank, member_name, total_points } = data;
  
  // Design logic based on rank
  let bgClass = "bg-brand-card border-brand-main/20 hover:bg-brand-hover";
  let rankColor = "text-gray-400";
  let borderClass = "border border-transparent";
  let badge = null;

  if (rank === 1) {
    bgClass = "bg-gradient-to-r from-yellow-500/20 to-brand-card animate-glow";
    rankColor = "text-yellow-400 drop-shadow-[0_0_5px_rgba(255,215,0,0.8)]";
    borderClass = "border border-yellow-500/50";
    badge = "🥇";
  } else if (rank === 2) {
    bgClass = "bg-gradient-to-r from-slate-300/20 to-brand-card";
    rankColor = "text-slate-300";
    borderClass = "border border-slate-300/50";
    badge = "🥈";
  } else if (rank === 3) {
    bgClass = "bg-gradient-to-r from-amber-600/20 to-brand-card";
    rankColor = "text-amber-500";
    borderClass = "border border-amber-600/50";
    badge = "🥉";
  } else if (rank === 4) {
    bgClass = "bg-brand-card";
    rankColor = "text-brand-main";
    borderClass = "border border-brand-main/80 shadow-[0_0_8px_rgba(0,169,95,0.3)]";
    badge = (
      <span className="text-[10px] bg-brand-main text-white px-1.5 py-0.5 rounded-sm ml-1 whitespace-nowrap">
        ギフト圏内!
      </span>
    );
  }

  // Calculate progress bar width
  const percent = maxPoints > 0 ? Math.min(100, (total_points / maxPoints) * 100) : 0;

  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: rank * 0.05 }}
      className={`relative flex items-center p-3 rounded-lg mb-2 transition-all duration-300 ${bgClass} ${borderClass}`}
    >
      {/* Rank Indicator */}
      <div className="flex flex-col items-center justify-center w-12 flex-shrink-0">
        <span className={`text-xl md:text-2xl font-black italic ${rankColor}`}>
          {rank}
        </span>
        {typeof badge === 'string' ? (
          <span className="text-lg -mt-1">{badge}</span>
        ) : badge}
      </div>

      {/* Main Info */}
      <div className="flex-grow ml-3 min-w-0">
        <div className="flex justify-between items-baseline mb-1">
          <span className="font-bold text-gray-100 truncate pr-2" title={member_name}>
            {member_name || '名無し'}
          </span>
          <span className="font-black text-brand-accent text-lg flex-shrink-0 drop-shadow-[0_0_2px_rgba(255,215,0,0.5)]">
            {total_points.toLocaleString()} <span className="text-xs font-normal text-gray-400">pt</span>
          </span>
        </div>
        
        {/* Progress Mini Bar */}
        <div className="h-1.5 w-full bg-brand-dark rounded-full overflow-hidden">
          <motion.div 
            initial={{ width: 0 }}
            animate={{ width: `${percent}%` }}
            transition={{ duration: 1, delay: 0.5 }}
            className={`h-full rounded-full ${rank <= 4 ? 'bg-brand-accent' : 'bg-brand-main'}`}
          />
        </div>
      </div>
    </motion.div>
  );
}